import { render, staticRenderFns } from "./coperbizitravelaktarim.vue?vue&type=template&id=371f43f6&"
import script from "./coperbizitravelaktarim.vue?vue&type=script&lang=js&"
export * from "./coperbizitravelaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports